<template>
	<Row>
		<app-header></app-header>
		<Col span="8">&nbsp;</Col>
		<Col span="8">

		<div style="margin: 0px auto;margin-top: 80px;">
			<!--标题用户头部信息-->
			<div class="postingtitle" style="text-align: center;border-bottom: 1px solid rgb(238,238,238);height: 120px;">

				<span style="font-size: 24px;font-weight: bold;"> {{project.projectName}}</span>

				<br>
				<br>

				<span style="font-size: 20px;">    	
           
           	<Avatar style="background-color: #87d068" icon="person" />
           </span>
           		<span style="font-size: 18px;">创建时间：{{dateFormat(project.creationTime)}}</span>
           		<br>
				<span  @mouseenter="showUserDetail" @mouseleave="hideUserDetail" style="font-size: 18px;cursor: pointer;">{{userDetail.nickName}}</span>
				
				<!-- 弹出的个人详情预览框 -->
				<div v-show="isShowUserDetail" style="width: 300px;height: 160px;background-color: rgb(254,254,254);box-shadow: 1px 1px 5px 0px rgba(50, 50, 50, 0.75);border: 1px solid #cacaca;border-radius: 3px;position: relative;top: 10px;left: 350px;">
					<dl style="display: flex;">
						<dt style="margin: 20px;"><Avatar style="background-color: #87d068" icon="person" size="large"  /></dt>
						<dd style="margin: 12px;"><span style="font-weight: bold;font-size: 18px;">{{userDetail.nickName}}</span>
							<br />
							<span style="margin: 20px;color: rgb(120,145,150);">@{{userDetail.nickName}}</span>
							<br />
							<span style="margin-top:5px;"><Button type="primary" size="small">关注</Button></span>
							<p style="margin-top: 20px;">个人简介</p>
						</dd>
					</dl>
				</div>
			</div>
			<!-- 项目的描述，详情 -->
			<div class="projecrDesc">项目描述：
				{{project.projectDesc}} 
			</div>
            <!--项目评论，点赞，分享等-->
			<div class="postingbottom" style="margin-top: 50px;">
				<p>
					<span style="margin-left: 50px;">
						<Icon title="转发" type="forward" size="20" style="cursor: pointer;"></Icon>
					</span>&nbsp;&nbsp;&nbsp;&nbsp;
					<span @click="commentsshow" style="font-size: 14px;color:#A9A9A9;cursor: pointer;">评论  &nbsp;|</span>
					<span style="margin-left: 100px;">
						<Icon type="thumbsup" size="20" @click="supportProject" style="cursor: pointer;"></Icon>{{project.supportNumber}}
						&nbsp;
						<Icon  type="thumbsdown"  @click="opposeProject" size="20" style="cursor: pointer;"></Icon>{{project.opposeNumber}}
					</span>
					<span style="margin-left: 20px;" class="posting_shape">
						<Icon class="shape_twitter"  title="分享到推特" type="social-twitter" size="20" style="cursor: pointer;"></Icon>&nbsp;&nbsp;
						<Icon  class="shape_facebook"  title="分享到脸书" type="social-facebook" size="20" style="cursor: pointer;"></Icon>&nbsp;&nbsp;
						<Icon  class="shape_google"  title="分享到谷歌" type="social-google" size="20" style="cursor: pointer;"></Icon>&nbsp;&nbsp;
						<Icon  class="shape_reddit" title="shape on reddit" type="social-reddit" size="20" style="cursor: pointer;"></Icon>&nbsp;&nbsp;
						<Icon  class="shape_linkedin" title="分享到linkedin" type="social-linkedin" size="20" style="cursor: pointer;"></Icon>&nbsp;&nbsp;
					</span>
					<!--
					<div class="postinguserinfo1" v-show="isuserinfoShow1" style="width: 300px;height: 160px;background-color: rgb(254,254,254);box-shadow: 1px 1px 5px 0px rgba(50, 50, 50, 0.75);border: 1px solid #cacaca;border-radius: 3px;position: relative;top: 10px;left: 150px;">
						<dl style="display: flex;">
							<dt style="margin: 20px;"><Avatar style="background-color: #87d068" icon="person" size="large"  /></dt>
							<dd style="margin: 12px;"><span style="font-weight: bold;font-size: 18px;">用户名称</span>
								<br />
								<span style="margin: 20px;color: rgb(120,145,150);">@用户名称</span>
								<br />
								<span style="margin-top:5px;"><Button type="primary" size="small">关注</Button></span>
								<p style="margin-top: 20px;">个人简介</p>
							</dd>

						</dl>

					</div>
					-->
				</p>
			</div>
           <!--评论框-->
			<div class="projectComment" v-show="isShowcomments">
				<Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
					<FormItem prop="commentProjectId">
						<Input v-model="formValidate.commentProjectId" type="hidden"></Input>
					</FormItem>
					<FormItem prop="commentText">
						<Input v-model="formValidate.commentText" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input>
					</FormItem>

					<FormItem>
						<Button type="primary" @click="submitComment('formValidate')">Submit</Button>
						<Button type="ghost"  @click="closeComment('formValidate')" style="margin-left: 8px">close</Button>
					</FormItem>
				</Form>

			</div>
			<!-- 中间灰色条 -->
			<div style="height: 60px;border-bottom: 1px solid rgb(238,238,238);border-top: 1px solid rgb(238,238,238);margin-top: 20px;background-color: #A9A9A9;">
			</div>
			<!-- 评论 -->
			<div v-for="(comment,index) in projectCommentList" class="comments"  style="margin-top: 10px;">
				<dl style="display: flex;font-family: inherit;font-size: 14px;">
					<dt><Avatar style="background-color: #87d068" icon="person" size="large"/>
					</dt>
					<dd>
						<span><a>{{userDetail.nickName}}</a>&nbsp;发表于</span>
						<span>{{dateFormat(comment.commentTime)}}</span>
						<br>
						<Icon type="thumbsup" size="20" @click="" style="cursor: pointer;"></Icon>{{comment.supportNumber}}
						&nbsp;
						<Icon  type="thumbsdown"  @click="" size="20" style="cursor: pointer;"></Icon>{{comment.opposeNumber}}
						<span class="toggletext" style="margin-left: 400px;color: rgb(224,224,224);cursor: pointer;" @click="toggletext(index)">
						<Icon @click="q" type="chevron-down"></Icon></span>
						<br />
						<span class="commentText" v-show="isShowCommentText">
						{{comment.commentText}}
						</span>
					</dd>
				</dl>
				<div v-for="childComment in comment.projectCommentList" style="margin-left: 40px">
					<br>
					<dl style="display: flex;font-family: inherit;font-size: 14px;">
						<dt><Avatar style="background-color: #87d068" icon="person" size="large"/>
						</dt>
						<dd>
							<span><a>{{userDetail.nickName}}</a>&nbsp;发表于</span>
							<span>{{dateFormat(childComment.commentTime)}}</span>
							<br>
							<Icon type="thumbsup" size="20" @click="" style="cursor: pointer;"></Icon>{{childComment.supportNumber}}
							&nbsp;
							<Icon  type="thumbsdown"  @click="" size="20" style="cursor: pointer;"></Icon>{{childComment.opposeNumber}}
							<span class="toggletext" style="margin-left: 300px;color: rgb(224,224,224);cursor: pointer;" @click="toggletext(index)">
							<Icon @click="q" type="chevron-down"></Icon></span>
							<br>
							<span class="commentText" v-show="isShowCommentText">
							{{childComment.commentText}}
							</span>
						</dd>
					</dl>
				</div>
			</div>	
		</div>
		</Col>
		<Col span="8">&nbsp;</Col>
	</Row>
</template>

<script>
  	import config from '../../config.js'
	export default {
		data() {
		    const commentText = (rule, value, callback) => {
			/*评论内容验证*/
		      if (value == 0) {
		        callback(new Error('Please enter a personal introduction'));
		      }
		      else if (value <10) {
		        callback(new Error('Introduce no less than 10 words'));
		      }
		      else {
		        callback();
		      }
		    };
			return {
				project: [],
				userDetail: [],
				projectCommentList: [],
				isShowUserDetail: false,
				isShowCommentText:true,
				isShowcomments: false,
				formValidate: {
					commentProjectId: '',
					commentText: ''
				},
				ruleValidate: {
					commentText: [
						{ required: true, validator: commentText, trigger: 'blur' }				
					]
				}
			}
		},
		//页面重新加载时执行的方法
		watch:{
			'$route':'projectDetail'
		},
		//页面加载时候就执行的内容
		mounted: function() {
			 this.projectDetail();
		},
		methods: {
			//项目详情
			projectDetail:function(){
				let projectId= this.$route.params.projectId;
				let userId= this.$route.params.userId;
				let projectUrl = config.baseUrl + "project/projectDetail/" + projectId;
				let that = this;
				that.formValidate.commentProjectId = projectId;
				this.$http.get(projectUrl).then(function(successData) {
					let data = successData.data;
					that.project = data.result;
				}, function(errorData) {
					this.$Message.error("Sorry, server error!");
				});
				let userUrl = config.baseUrl + "user/userDetail/" + userId;
				this.$http.get(userUrl).then(function(successData) {
					let data = successData.data;
					that.userDetail = data.result;
				}, function(errorData) {
					this.$Message.error("Sorry, server error!");
				});
				let commentUrl = config.baseUrl + "projectComment/getProjectComment/" + projectId;
				this.$http.get(commentUrl).then(function(successData) {
					let data = successData.data;
					that.projectCommentList = data.result;
				}, function(errorData) {
					this.$Message.error("Sorry, server error!");
				});

			},
			//点击评论，弹出评论框
			commentsshow: function() {
				this.isShowcomments = !this.isShowcomments;
			},
			//提交项目评论
			submitComment(name) {
				this.$refs[name].validate((valid) => {
					if(valid) {
					 let url = config.baseUrl + "projectComment/addProjectComment";
                     let that =this;
                     this.$http.post(url,this.formInline,this.ruleInline).then(function(successData){
                     let data = successData.data;
                     if (data.resCode == 0) {
                     	this.$Message.success('Success!');                                      
                     }else if (data.resCode == -1) {
                     	this.$Message.error('Fail!');
                     }
                },function(errorData){
                     this.$Message.error('Fail!');
                });
				} else {
					this.$Message.error('Fail!');
				}
				})
			},
			//关闭评论框
			closeComment(name) {
				this.isShowcomments = false;
				this.$refs[name].resetFields();   
			},
			//用户信息显示
			showUserDetail: function() {
				this.isShowUserDetail = !this.isShowUserDetail;
			},
			//用户信息隐藏
			hideUserDetail: function() {
				let that = this;
				setTimeout(function () {
            		that.isShowUserDetail = !that.isShowUserDetail;
          		}, 1000);
			},
			//评论内容的缩放
			toggletext:function(index){
				this.isShowCommentText = !this.isShowCommentText;
			},
			//项目点赞/取消赞
			supportProject: function(event) {
				let projectId= this.$route.params.projectId;
				let url = config.baseUrl + "project/support/" + projectId;
                this.$http.get(url).then(function(successData){
                    let that = this;
                    let data = successData.data;
                    if(event.target.style.color == 'red') {
						event.target.style.color = 'gray';
					} else {
						event.target.style.color = 'red';
					}
                    if (data.resCode == 0) {
                        //在页面给点赞数加1
                        that.project.supportNumber = data.result;
                    }else if (data.resCode == 1) {
                        //在页面给点赞数减1
                        that.project.supportNumber = data.result;
                    }
                },function(errorData){
                    this.$Message.error("Fail!");
                });
			},
			//项目点踩/取消踩
			opposeProject:function(event){
				let projectId= this.$route.params.projectId;
                let url = config.baseUrl + "project/oppose/" + projectId;
                this.$http.get(url).then(function(successData){
                    let that = this;
                    let data = successData.data;
                    if(event.target.style.color == 'red') {
						event.target.style.color = 'gray';
					} else {
						event.target.style.color = 'red';
					}
                    if (data.resCode == 0) {
                        //在页面给点踩数加1
                        that.project.opposeNumber = data.result;
                    }else if (data.resCode == 1) {
                        //在页面给点踩数减1
                        that.project.opposeNumber = data.result;
                    }
                },function(errorData){
                    this.$Message.error("Fail!");
                });
            },
			//时间格式化函数
            dateFormat(time) {
				return formatDate(time);
			},

            /**
             * stopPropagation:function() {
            	var ev = e || window.event;
	            if (ev.stopPropagation) {
	                ev.stopPropagation();
	            }else if (window.event) {
	                window.event.cancelBubble = true;//兼容IE
	            }
	        },
             */
            
		}
	}
</script>

<style>	
	.projecrDesc {
		font-family: 'Source Serif Pro', serif;
		font-size: 20px;
		font-weight: 700;
		text-indent: 2em;
		word-spacing: 2px; 
	}
	
	.shape_twitter:hover {
		color: rgb(135, 208, 104);
	}
	
	.shape_facebook:hover {
		color: rgb(135, 208, 104);
	}
	
	.shape_google:hover {
		color: rgb(135, 208, 104);
	}
	
	.shape_reddit:hover {
		color: rgb(135, 208, 104);
	}
	
	.shape_linkedin:hover {
		color: rgb(135, 208, 104);
	}
	
</style>


// WEBPACK FOOTER //
// ProjectDetail.vue?689ef93a